<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="content-group-setttings-dialog" *ngIf="!isLoading; else loadingSpinner">
                <div class="title">
                    <div>
                        {{
                            initialSetting
                                ? ('alarm-groups-settings.dialog.edit' | translate)
                                : ('alarm-groups-settings.dialog.save' | translate)
                        }}
                    </div>
                    <div class="group-name">{{ groupName }}</div>
                </div>
                <div class="address-container">
                    <ng-container *ngFor="let outputSetting of outputSettings">
                        <app-output-setting
                            [outputSetting]="outputSetting"
                            [vesselSlots]="vesselSlots"
                            (onDeleteSetting)="handleDeleteSetting(outputSetting)"></app-output-setting>
                    </ng-container>
                </div>
                <div class="add-output-container">
                    <div class="output-footer-button" (click)="addSetting()" [class.disabled]="isAddSettingDisabled()">
                        {{ 'alarm-groups-settings.dialog.add' | translate }}
                    </div>
                    <div class="output-footer-num">
                        {{
                            'alarm-groups-settings.dialog.num'
                                | translate
                                    : {
                                          num: outputSettings?.length || 0,
                                      }
                        }}
                    </div>
                </div>
            </div>
            <div class="buttons-container">
                <div class="cancel button" (click)="clearForm()">
                    {{ 'dlg.cancel' | translate }}
                </div>
                <div
                    class="create button"
                    data-cy="ops-settings-console-settings-modal-submit-button"
                    [ngClass]="{ button_disabled: isButtonDisabled() }"
                    (click)="save()">
                    {{
                        initialSetting
                            ? ('alarm-groups-settings.dialog.edit' | translate)
                            : ('alarm-groups-settings.dialog.save' | translate)
                    }}
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loadingSpinner>
    <div class="content-group-setttings-dialog">
        <app-loading-spinner></app-loading-spinner>
    </div>
</ng-template>
